@if (mappingRule(); as mappingRule) {
  <div class="rule-box">
    <div class="border-l-2 border-primary-500 pl-2">
      @switch (mappingRule.mappingType) {
        @case ('attribute') {
          <em-operand-with-icon
            class="condition-pill !inline-flex"
            [operand]="simpleMappingValue()"
          ></em-operand-with-icon>
        }
        @case ('static_value') {
          <em-operand-with-icon
            class="condition-pill !inline-flex"
            [operand]="simpleMappingValue()"
          ></em-operand-with-icon>
        }
        @case ('combine_attributes') {
          <div class="flex gap-2">
            @for (attr of combinedAttrMappingValue(); track $index) {
              <em-operand-with-icon
                class="condition-pill gap-2"
                [operand]="attr"
              ></em-operand-with-icon>
            }
          </div>
        }
        @case ('calculation') {
          <div class="inline-flex condition-pill gap-2">
            @if (calculationMappingValue()) {
              <em-icon [name]="'calculate'" class="text-primary-300"></em-icon>
              {{ calculationMappingValue().attribute_name }}
              @switch (calculationMappingValue().operator) {
                @case ('plus') {
                  <div>+</div>
                }
                @case ('minus') {
                  <div>-</div>
                }
                @case ('multiple') {
                  <div>*</div>
                }
                @case ('divide') {
                  <div>/</div>
                }
                @case ('increase_by_percentage') {
                  <div class="flex gap-1">
                    <span class="text-success-500">&uarr;</span>%
                  </div>
                }
                @case ('decrease_by_percentage') {
                  <div class="flex gap-1">
                    <span class="text-danger-500">&darr;</span>%
                  </div>
                }
              }
              {{ calculationMappingValue().value }}
            }
          </div>
        }
        @case ('leave_empty') {
          <div class="condition-pill inline-flex gap-2">
            <em-icon [name]="'hide_source'" class="text-primary-300"></em-icon>
            {{ 'MAPPING_ENGINE_MAPPING_TYPE_EMPTY' | translate }}
          </div>
        }
      }
    </div>

    @if (mappingRule.conditionalStatementList?.conditionalStatements?.length) {
      <div class="flex gap-4 mt-2 ml-12 pb-2">
        <div class="if-label">{{ 'SHARED_LABEL_ONLY_IF' | translate }}:</div>
        <div class="logic-group root">
          @for (
            statementsList of mappingRule.conditionalStatementList
              ?.conditionalStatements;
            track $index
          ) {
            @if ($index > 0) {
              <span
                class="logic-operator"
                [ngClass]="
                  'logic-operator--' +
                  mappingRule.conditionalStatementList?.logicalOperator?.toLowerCase()
                "
              >
                {{
                  mappingRule.conditionalStatementList?.logicalOperator?.toUpperCase()
                }}
              </span>
            }
            <div
              class="logic-group"
              [ngClass]="
                mappingRule.conditionalStatementList?.conditionalStatements
                  ?.length === 1
                  ? '!border-none'
                  : getGroupClass(
                      statementsList.logicalOperator,
                      mappingRule.conditionalStatementList?.logicalOperator
                    )
              "
            >
              @for (condition of statementsList.conditions; track $index) {
                @if ($index > 0) {
                  <span
                    class="logic-operator"
                    [ngClass]="
                      'logic-operator--' +
                      statementsList.logicalOperator?.toLowerCase()
                    "
                  >
                    {{ statementsList?.logicalOperator?.toUpperCase() }}
                  </span>
                }

                @if (condition) {
                  <div class="condition-pill">
                    <span class="left-operand">
                      {{ condition.leftOperand?.value }}
                    </span>
                    <span class="arth-operator"
                      >{{
                        'OPERATOR_' + condition.operator?.toUpperCase()
                          | translate
                      }}
                    </span>
                    <span class="right-operand">
                      {{ condition.rightOperand?.value }}
                    </span>
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    }

    @if (mappingRule.additionalProcessor?.find_replace) {
      <div class="flex gap-4 mt-2 ml-12 border-gray-300 pb-2">
        <div class="if-label">Transformations:</div>
        <div class="flex gap-2">
          <div>{{ 'SHARED_LABEL_FIND' | translate }}</div>
          <div class="condition-pill left-operand">
            {{ mappingRule.additionalProcessor?.find_replace?.find }}
          </div>
          <div>{{ 'SHARED_LABEL_REPLACE_WITH' | translate }}</div>
          <div class="condition-pill left-operand">
            {{ mappingRule.additionalProcessor?.find_replace?.replace }}
          </div>
        </div>
      </div>
    }
  </div>
}
